import { render } from "./simpeg-kgb-prediksi-list.vue?vue&type=template&id=e27fe2f6"
import script from "./simpeg-kgb-prediksi-list.vue?vue&type=script&lang=js"
export * from "./simpeg-kgb-prediksi-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__